
<div class="rotate-actions-container" *ngIf="!showLoading">
	<button (click)="rotateLeft()" *ngIf="canvasLoaded" [disabled]="loadingData || !canvasLoaded" class="btn"><i class="fas fa-2x fa-rotate-left"></i></button>
	<button (click)="rotateRight()" *ngIf="canvasLoaded" [disabled]="loadingData || !canvasLoaded" class="btn"><i class="fas fa-2x fa-rotate-right"></i></button>
	<p-skeleton *ngIf="!canvasLoaded" width="10rem" height="4rem" borderRadius="16px"></p-skeleton>
</div>


<div class="canvas-image-container">
	<canvas #canvasRotateImage width="900" height='700' [class]="{'hidden-image': showLoading}"></canvas>
	<div class="child" #canvasImageContainer>
		<img *ngIf="photoIsAvailable"
			 [src]="previewPhoto"
			 (load)="onImageLoad()"
			 (error)="onImageError()">
	</div>

	<div class="smart-tag-empty-rules-message" *ngIf="!photoIsAvailable">
		<img src="assets/img/placeholder/No-file-asset.png">
		<label class="no-results">No Image Available</label>
	</div>

	<div class="render-loader" *ngIf="showLoading">
		<div class="card skeleton">
			<div class="card-body">
				<div class="row">
					<div class="col-md-2">
						<h5 class="card-title loading">&nbsp;</h5>
					</div>
				</div>
				<div class="card-img card-img-bottom loading">
					<div class="loader-icon">
						<i class="fas fa-images"></i>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>

<div class="actions-container">
	<button class="btn btn" [disabled]="loadingData" (click)="onDismiss()">
		Cancel
	</button>
	<p-button [loading]="loadingData" [disabled]="loadingData" (click)="saveImage()" label="Save"></p-button>
</div>
